import { type HttpClientInterface, type HttpClientRequestConfig } from 'core/infra/http/HttpClient'

import { type User } from '../domain/User'
import { mapApiToUser, type RawUser } from './userMapper'

export type UserRepositoryDependencies = {
  httpClient: HttpClientInterface
}

export class UserRepository {
  private httpClient: HttpClientInterface

  constructor({ httpClient }: UserRepositoryDependencies) {
    this.httpClient = httpClient
  }

  async getCurrentUser(config?: Partial<HttpClientRequestConfig>): Promise<User> {
    const endpoint = 'shipperguide/carrier/me'

    const response = await this.httpClient.get<RawUser>(endpoint, config)

    try {
      return mapApiToUser(response.data)
    } catch (error) {
      throw new Error('Failed to map API return to User', { cause: error as Error })
    }
  }
}
